module.exports = __webpack_public_path__ + "static/media/400006_02.0c6f34f9.png";